// ============================================================================
// BOOK · the stand-in reads shaped into indexes (ORD-BOOK-1b, 1e) — pure, so the
// app (bookSourcesApi) and a recount over the same rows give the same book
// ============================================================================
// Library rows: files_links ⨝ files_assets, every live model photo of the card's
// codes. Never a canceled photo, a canceled folder, a packing shot, or one decided
// canceled / irrelevant. Each row lands in one of three:
//   other  { CODE: { n: photo } }    a colour, no angle, not an option (newest per colour)
//   option { CODE: { n: [photo] } }  a "More option" / MO photo of that colour (no angle or side)
//   nocol  { CODE: [photo] }         no colour number (an unread name too; an option with no colour
//                                    carries option: true) — bookSources reads some of these tolerantly
// photo = { p, id, at, stored, name, unread?, option? }. A side photo with a colour is the side read's.
// Dev rows: developments — { dev: { DEV: primary url }, devAll: { DEV: [urls, primary first] } }.
// ============================================================================
import { getDevPrimaryImage } from '../../../utils/devCardUtils';
import { isCanceledName } from './bookFill';

const truthy = (v) => v === true || v === 'true';
export const isOption = (s) => !!s && s.option != null && s.option !== false && s.option !== 'false';
const newest = (a, b) => (!a || String(b.at || '') > String(a.at || '') ? b : a);

export function indexLibraryRows(rows) {
  const other = {}, option = {}, nocol = {};
  for (const r of rows || []) {
    const a = r.files_assets || {}, s = a.summary || {};
    if (truthy(s.canceled) || truthy(s.folderCanceled) || truthy(s.packing)) continue;
    if (['canceled', 'irrelevant'].includes(a.decision)) continue;
    if (isCanceledName(a.display_name || a.original_name)) continue;   // ORD-BOOK-1f: "canceled26080040 CL9388-10…"
    const angle = s.angle || '';
    if (angle && angle !== 'side') continue;                         // front, back, top … never stand in for a colour
    const n = String(s.colourNo == null ? '' : s.colourNo);
    const hasN = /^\d{1,3}$/.test(n);
    if (angle === 'side' && hasN && !isOption(s)) continue;          // the studio side photo: book_side_photos reads it
    const k = String(r.entity_key).toUpperCase();
    const ph = { p: a.storage_path, id: a.id, at: a.uploaded_at, stored: a.photo || {}, name: a.display_name || a.original_name || '' };
    if (truthy(s.unread)) { (nocol[k] = nocol[k] || []).push({ ...ph, unread: true }); continue; }
    if (isOption(s)) {
      if (hasN) { const o = (option[k] = option[k] || {}); (o[n] = o[n] || []).push(ph); }
      else (nocol[k] = nocol[k] || []).push({ ...ph, option: true });
      continue;
    }
    if (!hasN) { (nocol[k] = nocol[k] || []).push(ph); continue; }
    const o = (other[k] = other[k] || {});
    o[n] = newest(o[n], ph);
  }
  for (const k of Object.keys(option)) for (const n of Object.keys(option[k])) option[k][n].sort((x, y) => String(y.at).localeCompare(String(x.at)));
  return { other, option, nocol };
}

const urlOf = (img) => (typeof img === 'string' ? img : (img && img.url) || null);

export function indexDevRows(rows) {
  const dev = {}, devAll = {};
  for (const r of rows || []) {
    const k = String(r.dev_number || '').toUpperCase().trim();
    const images = Array.isArray(r.images) ? r.images : [];
    const url = getDevPrimaryImage({ images, primaryImageIndex: r.primaryImageIndex });
    if (!k || !url || dev[k]) continue;
    dev[k] = url;
    devAll[k] = [url, ...images.map(urlOf).filter((u) => u && u !== url)];
  }
  return { dev, devAll };
}
